import React, { useContext, useEffect } from 'react'
import Navbar from '../components/Navbar'
import { Outlet, useNavigate } from 'react-router-dom'
import UserContext from '../context/user/UserContext'
import Success from '../components/Success'

const Layout = () => {

  const { user } = useContext(UserContext)
  const token = localStorage.getItem("token")
  const navigate = useNavigate();

  useEffect(() => {
      if (!token || user.verfied === false) {
          navigate('/')
      }
  }, [token, user])

  return (
    <>
      <Success />
      <div className="main">
        <Navbar />
        <Outlet />
      </div>
    </>
  )
}

export default Layout
